import React from "react";
import { colorFromId, initials } from "./messages/helpers";

// Avatar partagé — n'existait pas côté web (chaque écran réimplémentait son propre cercle en
// ligne) ; port du composant mobile équivalent (components/messages/ui.tsx). Ajoute un anneau de
// statut Vibe optionnel, réutilisable partout où un profil de personne apparaît (Messages,
// Communautés, Lieux, Explorer). Un seul anneau à la fois — Real toujours prioritaire sur une
// Vibe simple, jamais les deux empilés.
export type VibeRingKind = "real" | "vibe" | null;
export const vibeRingKind = (hasReal?: boolean, hasActive?: boolean): VibeRingKind =>
  hasReal ? "real" : hasActive ? "vibe" : null;

export function Avatar({ id, name, uri, size = 50, online, showOnline, ringKind }: {
  id: string;
  name?: string;
  uri?: string;
  size?: number;
  online?: boolean;
  showOnline?: boolean;
  ringKind?: VibeRingKind;
}) {
  const dot = Math.round(size * 0.26);

  const photo = uri ? (
    <img src={uri} alt="" style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", display: "block" }} />
  ) : (
    <div style={{
      width: size, height: size, borderRadius: "50%", backgroundColor: colorFromId(id),
      display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontWeight: 700,
      fontSize: Math.max(9, size * 0.28),
    }}>
      {initials(name || "")}
    </div>
  );

  // Anneau ajouté AUTOUR de la photo (jamais rétréci pour lui faire de la place) — même
  // comportement que sur mobile, pour que la taille de photo reste identique avec ou sans anneau.
  let content = <div style={{ width: size, height: size }}>{photo}</div>;
  if (ringKind) {
    const gapW = Math.max(1.5, Math.round(size * 0.035));
    const ringW = Math.max(2, Math.round(size * 0.05));
    const outer = size + 2 * (ringW + gapW);
    content = (
      <div style={{
        width: outer, height: outer, borderRadius: "50%",
        background: ringKind === "real" ? "linear-gradient(135deg, #FF3B30, #E0367A)" : "#0a0a0a",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <div style={{
          width: size + 2 * gapW, height: size + 2 * gapW, borderRadius: "50%",
          border: `${gapW}px solid white`, overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          {photo}
        </div>
      </div>
    );
  }

  const gapW = Math.max(1.5, Math.round(size * 0.035));
  const ringW = Math.max(2, Math.round(size * 0.05));
  const boxSize = ringKind ? size + 2 * (ringW + gapW) : size;
  return (
    <div style={{ position: "relative", width: boxSize, height: boxSize, flexShrink: 0 }}>
      {content}
      {showOnline && online && (
        <div style={{
          position: "absolute", bottom: 0, right: 0, width: dot, height: dot, borderRadius: "50%",
          backgroundColor: "#0a0a0a", border: "2px solid white",
        }} />
      )}
    </div>
  );
}
